// KU – we'll need to update this list every time a new integration is activated
// in https://app.segment.com/philo/sources/web_prod/overview

export const INTEGRATIONS = [
  'Amplitude',
  'Facebook Pixel',
  'Google AdWords New',
  'Google Analytics 4',
  'Google Analytics',
  'Google Tag Manager',
  'Hotjar',
  'Pinterest Tag',
  'Twitter Ads',
];
